/* global fetch */
// @flow
export function checkStatus(response: any) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error: any = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    error.statusCode = response.status;
    console.log(error.response); // eslint-disable-line no-console
    throw error;
}

export function parseJSON(response: any): Promise<*> {
    return response.json();
}

export function graphQLRequest(query: string, token: string) {
    const baseAPI = process.env.REACT_APP_API_BASE || "";
    return fetch(baseAPI + "/graphql", {
        headers: {
            "Content-Type": "application/graphql",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        method: "POST",
        body: query
    })
        .then(checkStatus)
        .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/api/utils.js